<template>
  <div ref="messagesContainer" class="chat-messages">
    <div v-if="chatBotStore.messages.length === 0" class="empty-state">
      <div class="empty-icon">
        <img width="20" src="../img/KBuddyIcon.png" alt="KBuddy chat icon" />
      </div>
      <p>No messages yet. Start a conversation!</p>
    </div>

    <div v-for="message in chatBotStore.messages" :key="message.id" :class="['message', message.type]">
      <div class="message-avatar">
        <div v-if="message.type !== 'user'" class="user-avatar">
          <div class="bot-avatar"><img width="25" src="../img/KBuddyIcon.png" alt="KBuddy chat icon" /></div>
        </div>

        <div class="message-content">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="message-text" v-html="formatChatMessageWithSanitization(message)"></div>
          <div v-if="message.type !== 'user'" class="feedback-wrapper">
            <ul class="rating-form">
              <li>
                <button
                  :class="{ liked: feedbackState[message.id]?.rating === 'Response was useful' }"
                  @click="handleThumbsUp(message.id)"
                >
                  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5.92737 0.386684C5.98006 0.160245 6.18188 0 6.41437 0C7.52116 0 8.35387 0.807495 8.73277 1.90665C8.80081 2.10403 8.81405 2.30334 8.79703 2.48449L8.59212 4.66601H12.0112C12.3593 4.66601 12.6986 4.775 12.9816 4.97769C13.745 5.52453 13.8805 6.55534 13.388 7.27391C13.442 7.31199 13.4937 7.35376 13.5427 7.39909C14.1864 7.9946 14.1864 9.01224 13.5427 9.60774C13.4753 9.67006 13.4028 9.72567 13.3263 9.77416C13.6638 10.3772 13.5519 11.1672 12.9904 11.6461C12.8761 11.7435 12.7488 11.8225 12.613 11.8812C12.8073 12.3075 12.7915 12.8028 12.5656 13.2179C12.3034 13.6999 11.7986 14 11.2499 14H6.52785C6.02333 14 5.52479 13.8909 5.06636 13.6803L3.98337 13.1826C3.89757 13.6477 3.48993 14 3 14H1C0.447715 14 0 13.5523 0 13V5C0 4.44772 0.447715 4 1 4H3C3.52113 4 3.94915 4.39863 3.99579 4.90759L5.35974 2.70945C5.38851 2.66307 5.4095 2.6123 5.42187 2.55914L5.92737 0.386684ZM4 6.73272V12.0897L5.48393 12.7716C5.81137 12.9221 6.16748 13 6.52785 13H11.2499C11.4323 13 11.6001 12.9003 11.6872 12.74C11.7679 12.5917 11.7679 12.4125 11.6872 12.2642L11.6632 12.22C11.5927 12.0904 11.4587 12.0085 11.3118 12.0044H10.8002V11.5148L10.8001 11.5042L10.8002 11.4936V11.0044H11.2872L11.3001 11.0042L11.3217 11.0044H12.018C12.1366 11.0044 12.2512 10.9621 12.3414 10.8852C12.5747 10.6862 12.5747 10.3258 12.3414 10.1269C12.2542 10.0525 12.1441 10.0105 12.0297 10.0078H10.7858V9.00781L12.018 9.00768L12.0383 9.00781H12.5211C12.648 9.00781 12.7704 8.95991 12.8636 8.87368C13.0794 8.67402 13.0794 8.33282 12.8636 8.13316C12.7704 8.04692 12.648 7.99902 12.5211 7.99902H10.7858V6.99902L12.0112 6.99902C12.1504 6.99902 12.2861 6.95542 12.3993 6.87436C12.7705 6.60849 12.7705 6.05654 12.3993 5.79066C12.2861 5.7096 12.1504 5.66601 12.0112 5.66601H8.04295C7.90221 5.66601 7.76798 5.60669 7.67323 5.50262C7.57848 5.39855 7.53198 5.25937 7.54514 5.11925L7.80141 2.39097C7.80773 2.32368 7.80065 2.27108 7.78737 2.23255C7.56576 1.5897 7.19906 1.20992 6.79595 1.06629L6.39585 2.78577C6.35874 2.94525 6.29578 3.09757 6.20945 3.2367L4.12492 6.59614C4.09107 6.65067 4.04845 6.69643 4 6.73272ZM1 5H3V13H1V5Z"
                    />
                  </svg>
                </button>
              </li>
              <li>
                <button
                  :class="{ disliked: feedbackState[message.id]?.rating === 'Response was not useful' }"
                  @click="handleThumbsDown(message.id)"
                >
                  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.09802 13.6133C8.04533 13.8398 7.84351 14 7.61103 14C6.50423 14 5.67152 13.1925 5.29262 12.0933C5.22458 11.896 5.21134 11.6967 5.22836 11.5155L5.43327 9.33399H2.01422C1.66613 9.33399 1.32679 9.225 1.04381 9.02231C0.28036 8.47547 0.144906 7.44466 0.637436 6.72609C0.583439 6.68801 0.531736 6.64624 0.482733 6.60091C-0.16099 6.0054 -0.16099 4.98776 0.482733 4.39226C0.550098 4.32994 0.622558 4.27433 0.699077 4.22584C0.361554 3.62285 0.473537 2.83284 1.03503 2.35394C1.1493 2.25648 1.27663 2.17753 1.41239 2.11879C1.21813 1.69247 1.23392 1.1972 1.45975 0.782083C1.72198 0.300055 2.22679 0 2.77553 0H7.49754C8.00206 0 8.50061 0.109071 8.95903 0.319738L10.042 0.817426C10.1278 0.352324 10.5355 0 11.0254 0H13.0254C13.5777 0 14.0254 0.447715 14.0254 1V9C14.0254 9.55228 13.5777 10 13.0254 10H11.0254C10.5043 10 10.0762 9.60137 10.0296 9.09241L8.66565 11.2906C8.63688 11.3369 8.61589 11.3877 8.60352 11.4409L8.09802 13.6133ZM10.0254 7.26728V1.91032L8.54146 1.22838C8.21402 1.07791 7.85791 1 7.49754 1H2.77553C2.59313 1 2.42534 1.09974 2.33817 1.25996C2.25747 1.40831 2.25747 1.58746 2.33817 1.73581L2.3622 1.77997C2.43269 1.90955 2.56672 1.99147 2.71359 1.99561H3.22515V2.48517L3.22526 2.49577L3.22515 2.50637V2.99561H2.7382L2.72526 2.99577L2.70368 2.99561H2.00736C1.88881 2.99561 1.77415 3.03786 1.68396 3.11479C1.45068 3.31375 1.45068 3.67418 1.68396 3.87314C1.77119 3.94754 1.88131 3.98951 1.99569 3.99219H3.23959V4.99219L2.00736 4.99232L1.98713 4.99219H1.50434C1.37735 4.99219 1.25503 5.04009 1.16181 5.12632C0.945984 5.32598 0.945984 5.66718 1.16181 5.86684C1.25503 5.95308 1.37735 6.00098 1.50434 6.00098H3.23959V7.00098L2.01422 7.00098C1.87501 7.00098 1.73929 7.04458 1.62611 7.12564C1.25492 7.39151 1.25492 7.94346 1.62611 8.20934C1.73929 8.2904 1.87501 8.33399 2.01422 8.33399H5.98244C6.12318 8.33399 6.25741 8.39331 6.35216 8.49738C6.44691 8.60145 6.49341 8.74063 6.48025 8.88075L6.22398 11.609C6.21766 11.6763 6.22474 11.7289 6.23802 11.7675C6.45963 12.4103 6.82633 12.7901 7.22944 12.9337L7.62954 11.2142C7.66665 11.0548 7.72961 10.9024 7.81594 10.7633L9.90048 7.40386C9.93432 7.34933 9.97694 7.30357 10.0254 7.26728ZM13.0254 9H11.0254V1H13.0254V9Z"
                    />
                  </svg>
                </button>
              </li>
            </ul>
            <div
              v-if="
                feedbackState[message.id]?.rating === 'Response was not useful' && !feedbackState[message.id]?.submitted
              "
              class="submit-feedback"
            >
              <textarea
                rows="3"
                placeholder="Share feedback (required)"
                class="feedback-textarea"
                :value="feedbackState[message.id]?.text || ''"
                @input="setFeedbackText(message.id, ($event.target as HTMLTextAreaElement).value)"
              />
              <div class="feedback-info">
                Your conversation will be included with your feedback to help improve our analysis.
              </div>
              <div class="feedback-button opposite-ends">
                <div class="message-time">{{ formatTime(message.timestamp) }}</div>
                <button id="submitFeedback" class="submit" @click="submitFeedback(message.id)">Submit feedback</button>
              </div>
            </div>
            <div v-if="feedbackState[message.id]?.submitted" class="feedback-sent">
              Your feedback was successfully sent. Thank you for helping us improve KBuddy!
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useChatBotStore } from "../stores/chatBotStore";
import { formatTime, scrollToBottom } from "../helpers/common";
import { onMounted, ref, reactive, watch } from "vue";
import DOMPurify from "dompurify";
import { FeedbackEntry, IChatEvalRequest, IChatMessage } from "@/chatBot/interfaces/chatBotInterfaces";
import { chatBotApi } from "@/common";
import { formatChatMessage } from "format-chat-message";

const chatBotStore = useChatBotStore();

const messagesContainer = ref<HTMLElement>();

const feedbackState = reactive<Record<string, FeedbackEntry>>({});

const handleThumbsUp = async (messageId: string) => {
  // Set the rating state so the 'liked' class is applied
  if (!feedbackState[messageId]) {
    feedbackState[messageId] = { rating: "", text: "" };
  }
  feedbackState[messageId].rating = "Response was useful";

  // Submit thumbs up feedback to API
  try {
    const request: IChatEvalRequest = {
      notes: "",
      sessionId: chatBotStore.sessionId,
      messageId: parseInt(messageId),
      evaluationType: "like",
    };
    await chatBotApi.chatEval(request);
    console.log("Thumbs up submitted successfully");
  } catch (error) {
    console.error("Failed to submit thumbs up feedback:", error);
  }
};

const handleThumbsDown = (messageId: string) => {
  // Set the rating state so the 'disliked' class is applied and feedback section shows
  if (!feedbackState[messageId]) {
    feedbackState[messageId] = { rating: "", text: "" };
  }
  feedbackState[messageId].rating = "Response was not useful";
};

const setFeedbackText = (messageId: string, text: string) => {
  if (!feedbackState[messageId]) {
    feedbackState[messageId] = { rating: "", text: "" };
  }
  feedbackState[messageId].text = text;
};

const submitFeedback = async (messageId: string) => {
  const feedback = feedbackState[messageId];
  if (!feedback?.rating) return;

  try {
    const request: IChatEvalRequest = {
      notes: feedback.text || "",
      sessionId: chatBotStore.sessionId,
      messageId: parseInt(messageId),
      evaluationType: "dislike",
    };
    await chatBotApi.chatEval(request);
    feedbackState[messageId].submitted = true;
    console.log("Feedback submitted successfully");
  } catch (error) {
    console.error("Failed to submit feedback:", error);
  }
};

function formatChatMessageWithSanitization(message: IChatMessage) {
  // Clean up malformed HTML URLs from backend response
  let cleanedText = normalizeMalformedUrls(message.text);

  // Sanitize to prevent XSS
  cleanedText = sanitizeHtml(cleanedText);

  // Format the message (handles markdown, URLs, etc. - only call once)
  let htmlText = formatChatMessage({ message: cleanedText });

  // Replace markdown bullets with HTML spaces for better formatting
  htmlText = htmlText.replaceAll("* ", "&nbsp;&nbsp;&nbsp;&nbsp;");

  return htmlText;
}

// Normalize malformed anchor/URL text that the backend can emit as plain-text stream content.
// Each step targets a specific pattern; order matters.
function normalizeMalformedUrls(text: string): string {
  let result = text;

  // 1. Remove any leaked placeholder tokens from earlier processing attempts.
  result = result.replace(/_+URL_PLACEHOLDER_\d+_*/gi, "");

  // 2. Unwrap complete anchor tags to their bare href URL.
  result = result.replace(/<a\b[^>]*href=["']?(https?:\/\/[^"'\s>]+)[^>]*>[^<]*<\/a>/gi, "$1");

  // 3. Unwrap opening-only anchor tags (no closing tag) to their bare href URL.
  result = result.replace(/<a\b[^>]*href=["']?(https?:\/\/[^"'\s>]+)[^>]*>/gi, "$1");

  // 4. Strip malformed anchor attribute tails the backend emits as plain text.
  result = result.replace(/(https?:\/\/[^\s<>"]+)\s+(?:(?:target|rel|href)=[^>\n]*)>(?:https?:\/\/[^\s<>"]+)?/gi, "$1");

  // 5. Clean any residual HTML entities or embedded duplicates within bare URLs.
  result = result.replace(/https?:\/\/[^\s<>]+/gi, rawUrl => {
    let clean = rawUrl
      .replace(/&quot;|&#34;|&amp;/gi, "")
      .replace(/["'`]+/g, "")
      .trim();

    // Remove a second URL embedded within the same URL string.
    const secondHttpIndex = clean.indexOf("http", clean.indexOf("http") + 1);
    if (secondHttpIndex > -1) {
      clean = clean.slice(0, secondHttpIndex);
    }

    return clean.replace(/[)>.,;:]+$/g, "");
  });

  return result;
}

//Use package to sanitize HTML content to prevent XSS attacks
const sanitizeHtml = (html: string) => DOMPurify.sanitize(html);

onMounted(() => {
  scrollToBottom(messagesContainer.value!);
});

watch(
  () => chatBotStore.messages,
  () => {
    scrollToBottom(messagesContainer.value!);
  },
  { deep: true }
);
</script>
